import { applyMiddleware, compose, createStore } from "redux";
import {
  apiErrorMessage,
  getBalance,
  getMemberData,
  initializeApi,
  periodicDataUpdater,
  userLogout,
} from "./middleware";
import AllReducers from "./reducers/AllReducers";

const enhancers = [];
const middleware = [
  apiErrorMessage,
  periodicDataUpdater,
  initializeApi,
  getMemberData,
  getBalance,
  userLogout,
];

if (
  process.env.REACT_APP_SECRET_ENV === "development" &&
  window.__REDUX_DEVTOOLS_EXTENSION__
) {
  enhancers.push(window.__REDUX_DEVTOOLS_EXTENSION__());
}

const composedEnhancers = compose(applyMiddleware(...middleware), ...enhancers);

const store = createStore(AllReducers, composedEnhancers);

export default store;
